import { Component, computed, input, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MenuItemViewModel, MenuSectionConfig } from '../menu-grammar';
import { MenuItemComponent } from '../menu-item/menu-item.component';

@Component({
  selector: 'app-menu-section',
  templateUrl: './menu-section.component.html',
  styleUrl: './menu-section.component.scss',
  imports: [FormsModule, MenuItemComponent],
})
export class MenuSectionComponent {
  section = input.required<MenuSectionConfig>();
  iconOnly = input<boolean>(false);
  selectedId = input<string | number | null>(null);

  itemSelect = output<MenuItemViewModel>();

  searchValue = signal('');

  filteredItems = computed(() => {
    const items = this.section().items;
    const term = this.searchValue().trim().toLowerCase();
    if (!term) return items;
    return items.filter((item) =>
      item.title.toLowerCase().includes(term),
    );
  });
}
